import { useQuery } from 'react-query';
import { useLocalStorage } from '../hooks/useLocalStorage';
import { getRequestHeaders, vake_api_server_url } from './helpers';

export const useDetectionImage = (image_path: string) => {
    const [token] = useLocalStorage<string | null | undefined>('token', null);
    return useQuery(
        ['image', image_path],
        async () => {
            const res = await fetch(image_path, {
                credentials: 'include',
                headers: getRequestHeaders(token),
            });

            if (!res.ok) {
                throw new Error(res.statusText);
            }
            const blob = await res.blob();
            return URL.createObjectURL(blob);
        },
        {
            staleTime: Infinity,
        }
    );
};

export const usePlanetThumbnail = (image_path: string) => {
    const [token] = useLocalStorage<string | null>('token', null);
    return useQuery(
        ['id', image_path],
        async () => {
            const res = await fetch(image_path, {
                credentials: 'include',
                headers: getRequestHeaders(token),
            });
            if (!res.ok) {
                throw new Error(res.statusText);
            }

            const blob = await res.blob();
            return URL.createObjectURL(blob);
        },
        {
            staleTime: Infinity,
        }
    );
};

export const useEarthEngineImage = (
    lon: number,
    lat: number,
    date: Date,
    source: string,
    upsampleImage?: boolean,
    cached_file_name?: string
) => {
    const [token] = useLocalStorage<string | null>('token', null);
    const params = `lon=${lon}&lat=${lat}&timestamp=${date.toISOString()}${
        upsampleImage ? `&upsample=${upsampleImage}` : ''
    }${cached_file_name ? `&cached_file_name=${cached_file_name}` : ''}`;
    const url = `${vake_api_server_url}/insights/image/${source}?${params}`;

    return useQuery<string>(
        ['earth_engine_image', source, params],
        async () => {
            const res = await fetch(url, {
                credentials: 'include',
                headers: getRequestHeaders(token),
            });

            if (!res.ok) {
                throw new Error(res.statusText);
            }
            const blob = await res.blob();
            return URL.createObjectURL(blob);
        },
        {
            staleTime: Infinity,
            cacheTime: 1000 * 60 * 60 * 24 * 365,
            retry: 1, // Could test custom retryDelay to test more strict exponential backoff
        }
    );
};
